module.exports = __webpack_public_path__ + "img/jpg.c4db225a.svg";